export default __webpack_public_path__ + "static/media/google-play.0344b6d2.png";